module.exports = __webpack_public_path__ + "img/3e70114fcdff40d38e1164c134456b40.bc607690.jpg";